import { Icon, IconButton, Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormFieldValueTypeEnum } from "../../../_common/enum/forms/formFieldValueType.enum";
import { IFilteringViewModel } from "../../../_common/interface/table";
import { CommonTable } from "../../../_components/table/common.table";
import { PaperTableHeader } from "../../../_components/table/header.table";
import { SearchTableHeader } from "../../../_components/table/search.table";
import { formFieldKeyService } from "../../../_services/formFieldKey.service";

export function FormFieldKeyList2(params: { count: number, editorRef: React.MutableRefObject<any> }) {

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        search: '',
        limit: 100,
        page: 0,
        order: 'desc',
        orderBy: '',
        sectionName: null,
        label: null
    });
    let navigate = useNavigate();

    const { formTemplateSectionId } = useParams<{ formTemplateSectionId: string }>();
  
    useEffect(() => {
        fetchData();
    }, [filter, params.count]);

    function fetchData() {
        setLoading(true);

        let _data = {
            formTemplateSectionId: +(formTemplateSectionId || 0),
            sectionName: filter.sectionName,
            label: filter.label,
            //formFieldValueTypeId: filter.formFieldValueTypeId,
            //formFieldKeySpecialTypeId: filter.formFieldKeySpecialTypeId
        }

        return formFieldKeyService
            .getAll(_data)
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate(`EditFormFieldKey/${row.original.id}`) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'sectionOrder',
                header: 'Order',
            },
            {
                accessorKey: 'label',
                header: 'Label',
            },
            {
                accessorKey: 'formFieldValueTypeId',
                header: 'Type',
                accessorFn: (rowData: any) => <>{FormFieldValueTypeEnum[rowData.formFieldValueTypeId]}</>
            },
            {
                accessorKey: 'subSectionName',
                header: 'Section Name',
            },
            {
                accessorKey: 'subValues',
                header: 'Sub Values',
            },
            {
                accessorKey: 'id',
                header: '',
                accessorFn: (rowData: any) => <>{rowData.formFieldKeyLookupList && rowData.formFieldKeyLookupList.length ? rowData.formFieldKeyLookupList.map((m: any) => (m.label || m.lookupValue)).join(", ").toString() : ""}</>
            },

        ],
        [],
    );
    return (
        <>

            <PaperTableHeader title="Form Field Keys" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("CreateFormFieldKey") } }
            ]} />

            <SearchTableHeader inputs={[
                { label: "Section Name", name: "sectionName", onChange: setFilter, value: filter.sectionName },
                { label: "Label", name: "label", onChange: setFilter, value: filter.label },
            ]} />

            <Paper>
                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    // onDelete={onDelete}
                    loading={isLoading}
                />

            </Paper>
        </>
    );
}